import script from "./ConfirmButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmButton.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmButton.vue?vue&type=style&index=0&id=0d09ea98&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d09ea98"]])

export default __exports__